import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="relative w-full py-14 sm:py-20 px-4 overflow-hidden" style={{
    background: 'linear-gradient(180deg, #1a0000 0%, #120000 50%, #0a0a0a 100%)'
  }} data-id="element-303">
      {/* Red ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[400px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(ellipse, rgba(220,38,38,0.06) 0%, transparent 70%)'
    }} data-id="element-304" />

      <div className="relative max-w-2xl mx-auto text-center" data-id="element-305">
        {/* Label */}
        <motion.p className="text-red-500/70 text-xs font-bold tracking-[0.25em] uppercase mb-4" initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.4
      }} data-id="element-306">
          OFERTA POR TIEMPO LIMITADO
        </motion.p>

        {/* Heading */}
        <motion.h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-white mb-8 sm:mb-10 leading-tight" initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} data-id="element-307">
          El precio de lanzamiento
          <br data-id="element-308" />
          <span className="text-red-500" data-id="element-309">termina en:</span>
        </motion.h2>

        {/* Countdown */}
        <motion.div className="mb-6 sm:mb-8" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} data-id="element-310">
          <CountdownTimer size="lg" blinking={true} data-id="element-311" />
        </motion.div>

        {/* Price warning */}
        <motion.div className="inline-flex items-center gap-2 bg-red-950/40 border border-red-900/30 rounded-xl px-5 py-3 mb-10 sm:mb-12" initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.4,
        delay: 0.15
      }} data-id="element-312">
          <span className="text-red-500 text-sm" data-id="element-313">⚠️</span>
          <p className="text-white text-sm sm:text-base font-bold" data-id="element-314">
            Después sube{' '}
            <span className="text-red-500 font-black" data-id="element-315">$8.000 ARS</span> y no
            vuelve a bajar.
          </p>
        </motion.div>

        {/* Progress bar */}
        <motion.div className="bg-white/[0.03] border border-white/[0.06] rounded-xl p-5 sm:p-6" initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-316">
          <div className="flex items-center justify-between mb-3" data-id="element-317">
            <span className="text-red-400 font-bold text-xs sm:text-sm flex items-center gap-1.5" data-id="element-318">
              <span className="relative flex h-2 w-2" data-id="element-319">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-320" />
                <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" data-id="element-321" />
              </span>
              Cupos al precio de lanzamiento
            </span>
            <span className="text-white text-xs sm:text-sm font-black bg-red-500/15 px-2.5 py-1 rounded-md" data-id="element-322">
              Quedan pocos
            </span>
          </div>

          <div className="w-full bg-gray-800/60 rounded-full h-3 sm:h-3.5 overflow-hidden" data-id="element-323">
            <motion.div className="h-full rounded-full relative" style={{
            background: 'linear-gradient(90deg, #dc2626 0%, #f97316 100%)'
          }} initial={{
            width: '0%'
          }} whileInView={{
            width: '68%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.2,
            ease: 'easeOut',
            delay: 0.4
          }} data-id="element-324">
              {/* Shine effect on bar */}
              <div className="absolute inset-0 opacity-30" style={{
              background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.3) 50%, transparent 100%)',
              animation: 'shimmer 2s infinite'
            }} data-id="element-325" />
            </motion.div>
          </div>

          <div className="flex items-center justify-between mt-2.5" data-id="element-326">
            <p className="text-gray-600 text-[10px] sm:text-xs" data-id="element-327">
              Disponibilidad limitada
            </p>
            <p className="text-gray-400 text-[10px] sm:text-xs font-semibold" data-id="element-328">
              68% tomados
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}